import { FormGroup } from '@angular/forms';
import { AddressBaseDTO, HealthClaimDTO, PolicyType } from 'models/DTOs';

export enum MotorDamageType {
  Accident = 'Accident',
  FireLoss = 'FireLoss',
  Theft_AttemptedTheft = 'Theft_AttemptedTheft',
  WaterDamage = 'WaterDamage',
  GlassClaim = 'GlassClaim',
  Collision = 'Collision',
  FireWater = 'FireWater',
  Glass = 'Glass'
}

export enum HomeDamageType {
  Wind = 'Windstorm',
  Earthquake = 'Earthquake',
  Collision = 'Strike',
  FireDamage = 'Fire',
  WaterDamage = 'Flood',
  Theft = 'Theft',
  Other = 'Accident'
}

export enum HomeClaimPages {
  DAMAGE_TYPES,
  RISK_LOCATION,
  DAMAGED_PICTURES,
  EXPLAIN_INCIDENT,
  ADDITIONAL_INFO,
  ADDITIONAL_INFO_REPAIRS,
  ESTIMATED_DAMAGES,
  ADDITIONAL_PARTIES_INVOLVED,
  DOCUMENTS,
  DECLARATION
}

export enum MotorClaimPages {
  DAMAGE_TYPES,
  LOCATION,
  VEHICLE,
  INCIDENT_PHOTOS,
  DRIVER_INFO,
  INCIDENT_INFO,
  ACCIDENT_DETAILS,
  ADDITIONAL_INFO,
  ADDITIONAL_PARTIES_INVOLVED,
  DOCUMENTS,
  DECLARATION
}

export interface SubmitedClaim {
  form: FormGroup | any;
  newState: HomeClaimPages | MotorClaimPages;
}

export interface SelectVehicle {
  isSelected: boolean;
  name: string;
  model: string;
  registrationNumber: string;
  year: string;
  chassisNumber: string;
  colour: string;
  mileage: string;
  mortgage: string;
  policyId: string;
}

export interface SelectPropertyLocation {
  isSelected: boolean;
  location: string;
  risksList: SelectPropertyRisk[];
}
export interface SelectPropertyRisk {
  isSelected: boolean;
  location: string;
  policyId: string;
  riskId: string;
  description: string;
}

export interface DummyPerson {
  name: string;
  contactNumber: string;
}

export interface Participant {
  ownerName?: string;
  contactNumber?: string;
  driversName?: string;
  vehicleMake?: string;
  vehicleModel?: string;
  insuranceProvider?: string;
  insuranceNumber?: number;
  vehicleRegistration?: string;
  injuryDetails?: string;
  claimantName?: string;
  dateOfBirth?: Date;
  address?: string;
  employer?: string;
  occupation?: string;
  purposeOfVisit?: string;
  injuryDamageDescription?: string;
  relationship?: string;
  martialStatus?: string;
}

export enum IconPosition {
  TOP,
  RIGHT,
  BOTTOM,
  LEFT
}

export interface RiskAddressResDTO {
  riskId: string;
  policyID: string;
  locations: AddressBaseDTO;
}

export interface PageData {
  page: HomeClaimPages | MotorClaimPages;
  data: any;
}

export interface MotorClaimDTO {
  pageData: PageData[];
}

export interface HomeClaimDTO {
  pageData: PageData[];
}

export interface DraftClaim {
  type: PolicyType;
  claim: MotorClaimDTO | HomeClaimDTO | HealthClaimDTO;
  isDeleted?: boolean | undefined;
  isSigned?: boolean | undefined;
  isSubmited?: boolean | undefined;
  signatureUrl?: string | undefined;
}
